import { statsStrip } from "@/mocks/home";

export default function StatsStrip() {
  return (
    <section aria-label="整理数据概览" className="w-full bg-primary-800">
      <div className="mx-auto max-w-[1400px] px-4 py-10 md:px-6 md:py-12">
        <div className="grid gap-8 md:grid-cols-12 md:items-center">
          <div className="md:col-span-4">
            <h2 className="font-heading text-xl font-black leading-snug text-background-50 md:text-2xl">
              厚整理 · 可回溯
              <span className="mt-2 block text-sm font-normal text-primary-100">
                每一条归档都对应可核对的来源标注
              </span>
            </h2>
          </div>
          <div className="grid grid-cols-2 gap-4 md:col-span-8 md:grid-cols-4 md:gap-6">
            {statsStrip.map((stat, index) => (
              <div
                key={stat.label}
                className={`rounded-lg border border-primary-600/60 bg-primary-900/40 px-4 py-4 ${
                  index === 1 ? "border-accent-400/70 bg-accent-500/10" : ""
                }`}
              >
                <p className="font-heading text-2xl font-black text-background-50 md:text-3xl">
                  {stat.value}
                </p>
                <p className="mt-1 text-xs text-primary-100">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}